import React from 'react';
import { Icon } from '../../../../../../components';
import { ContainerInput, Label, ShowCount } from './styles';
import { useValidation } from './useValidation';

interface IinputMultiline {
  value?: string;
  setFieldValue: ({ name, value }: any) => void;
  name: string;
  validateOnStart?: boolean;
  validateForm: number;
  placeholder?: string;
  nameLabel: string;
  showCount?: boolean;
  setFieldError: ({ name, value }: any) => void;
  maxLength?: number;
  isRequired: boolean;
}

const InputMultiline = (props: IinputMultiline) => {
  const {
    value,
    setFieldValue,
    name,
    validateOnStart,
    validateForm,
    placeholder,
    nameLabel,
    showCount,
    maxLength,
    setFieldError,
    isRequired
  } = props;

  const { errorText, setValue } = useValidation({
    maxLength,
    value,
    validateOnStart,
    validateForm,
    setFieldError,
    setFieldValue,
    name,
    isRequired
  });

  return (
    <ContainerInput
      style={{ margin: '0 0 16px 0' }}
      data-testid="bse-form-inputMultiline"
    >
      {nameLabel && <Label color="#161d1f"> {nameLabel} </Label>}
      <textarea
        data-testid="bse-form-inputMultiline-input"
        autoComplete="off"
        value={value}
        name={name}
        className={`${value ? 'inputFilled' : ''} ${
          errorText ? 'inputError' : ''
        }`}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        rows={5}
        placeholder={placeholder}
      />
      {showCount && (
        <ShowCount error={errorText}>
          {errorText && (
            <div className="errorText">
              <Icon name="alert-triangle" size={12} />
              {errorText}
            </div>
          )}
          {errorText ? (
            ''
          ) : (
            <div>
              {value?.length ?? 0} / {maxLength}
            </div>
          )}
        </ShowCount>
      )}
    </ContainerInput>
  );
};

InputMultiline.defaultProps = {
  value: '',
  placeholder: 'Escribe aquí el detalle',
  maxLength: 200,
  showCount: true
};

export default InputMultiline;
